var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomaticPriorityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.17923,
    cy: 8,
    rx: 8.1791,
    ry: 8,
    fill: "#F9B609"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89886 8.87981L8.93086 6.23431C8.8832 6.11698 8.8337 5.97765 8.78236 5.81631C8.73103 5.65498 8.6797 5.48081 8.62836 5.29381C8.5807 5.48081 8.5312 5.65681 8.47986 5.82181C8.42853 5.98315 8.37903 6.12431 8.33136 6.24531L7.36886 8.87981H9.89886ZM12.5114 11.8828H11.3674C11.239 11.8828 11.1345 11.8516 11.0539 11.7893C10.9732 11.7233 10.9127 11.6426 10.8724 11.5473L10.2784 9.92481H6.98386L6.38986 11.5473C6.36053 11.6316 6.3037 11.7086 6.21936 11.7783C6.13503 11.848 6.03053 11.8828 5.90586 11.8828H4.75086L7.88036 3.92981H9.38736L12.5114 11.8828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticPriorityIcon);
export default __webpack_public_path__ + "static/media/automatic-priority-icon.ff2197c59e60cff46bcdd367b620c802.svg";
export { ForwardRef as ReactComponent };